import GTMEvent from "@/types/GTMEvent";

const category = "recipe";

export const viewLockedRecipe = {
  category,
  name: "locked",
  action: "view",
  label: "User has tried to viewed a recipe to which they do not have access",
} as GTMEvent;

export const recipeMetaLoaded = {
  category,
  name: "metaData",
  action: "loaded",
  label: "A recipe has been loaded",
} as GTMEvent;

export const recipeIngredientsLoaded = {
  category,
  name: "ingredients",
  action: "loaded",
  label: "A recipe's ingredients have been loaded",
};

const search = {
  viewLockedRecipe,
};

export default search;
